import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '@/common/SafeIcon';

const services = [
  {
    title: 'Ceramic Coating',
    desc: 'Long-lasting protection and unmatched gloss for your paint. Repels dirt and water effortlessly.',
    icon: FiIcons.FiShield,
    image: 'https://images.unsplash.com/photo-1601362840469-51e4d8d58785?auto=format&fit=crop&q=80&w=600'
  },
  {
    title: 'Paint Correction',
    desc: 'Remove swirls, scratches, and oxidation. Restore your clear coat to a mirror-like factory finish.',
    icon: FiIcons.FiSun,
    image: 'https://plus.unsplash.com/premium_photo-1661750334379-2f2b4b1f6ef4?auto=format&fit=crop&q=80&w=600'
  },
  {
    title: 'Interior Restoration',
    desc: 'Deep cleaning, leather conditioning, and odor removal to make your cabin feel brand new.',
    icon: FiIcons.FiDroplet,
    image: 'https://images.unsplash.com/photo-1771491237225-01931a752f58?auto=format&fit=crop&q=80&w=600'
  }
];

const ServicesPreview = () => {
  return (
    <section className="py-24 bg-primary relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-accent text-sm font-bold tracking-widest uppercase mb-2 block">Our Expertise</span>
          <h2 className="text-4xl md:text-5xl font-heading font-bold mb-4">Signature Services</h2>
          <p className="text-textMuted max-w-2xl mx-auto">Meticulous attention to detail combined with industry-leading products to deliver extraordinary results.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, idx) => (
            <motion.div 
              key={idx}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.2 }}
              className="group relative rounded-2xl overflow-hidden bg-secondary border border-white/5"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img src={service.image} alt={service.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110 opacity-80 group-hover:opacity-100" />
              </div>
              <div className="p-8 relative z-10 bg-gradient-to-t from-secondary via-secondary to-transparent -mt-20">
                <div className="bg-primary w-12 h-12 rounded-full flex items-center justify-center mb-4 border border-white/10 shadow-lg">
                  <SafeIcon icon={service.icon} className="text-accent text-xl" />
                </div>
                <h3 className="text-2xl font-heading font-bold mb-3">{service.title}</h3>
                <p className="text-textMuted mb-6 line-clamp-2">{service.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
        
        <div className="mt-16 text-center">
          <Link to="/services" className="btn-outline">View All Services</Link>
        </div>
      </div>
    </section>
  );
};

export default ServicesPreview;